var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternetSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    viewBox: "0 0 558.896 558.896",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff"
    },
    cx: 280.896,
    cy: 279.448,
    r: 256
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff"
    },
    cx: 280.896,
    cy: 279.448,
    r: 256
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e82171"
    },
    d: "M270.064,548.408c-159.344-267.312-1.6-537.232,0.016-539.936l13.728,8.224 c-1.568,2.608-154.368,264.56,0,523.52L270.064,548.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e82171"
    },
    d: "M231.968,550.424c-1.536-0.848-154.032-87.744-154.032-270.304 c0-182.512,151.936-269.424,153.472-270.288l7.808,13.968c-1.456,0.816-145.28,83.392-145.28,256.32 c0,173.248,144.336,255.52,145.808,256.336L231.968,550.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e82171"
    },
    d: "M291.728,548.408l-13.744-8.192c154.368-258.96,1.568-520.912,0-523.52l13.728-8.224 C293.328,11.176,451.072,281.096,291.728,548.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e82171"
    },
    d: "M329.824,550.424l-7.776-13.968c1.456-0.816,145.808-83.392,145.808-256.336 c0-172.928-143.824-255.504-145.28-256.32l7.808-13.968c1.536,0.864,153.472,87.76,153.472,270.288 C483.856,462.664,331.344,549.576,329.824,550.424z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.944,
    y: 166.744,
    style: {
      fill: "#e82171"
    },
    width: 553.616,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    y: 376.088,
    style: {
      fill: "#e82171"
    },
    width: 558.896,
    height: 16
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.016,
    y: 179.592,
    style: {
      fill: "#ffffff"
    },
    width: 552,
    height: 198.192
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e82171"
    },
    d: "M107.584,324.408l-28.48-90.032h23.136l16.88,59.008l15.52-59.008h22.976l15.008,59.008 l17.216-59.008h23.488L184.4,324.408h-22.896l-15.52-57.904l-15.264,57.904H107.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e82171"
    },
    d: "M242.624,324.408l-28.48-90.032h23.136l16.88,59.008l15.52-59.008h22.976l15.008,59.008 l17.216-59.008h23.488l-28.912,90.032H296.56l-15.52-57.904l-15.264,57.904L242.624,324.408L242.624,324.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e82171"
    },
    d: "M377.68,324.408l-28.48-90.032h23.136l16.88,59.008l15.52-59.008h22.976l15.008,59.008 l17.216-59.008h23.488l-28.928,90.032H431.6l-15.52-57.904l-15.264,57.904H377.68z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetSvgrepoCom1);
export default __webpack_public_path__ + "static/media/internet-svgrepo-com (1).9f3718240e76c25d58dd52727033936f.svg";
export { ForwardRef as ReactComponent };